import React, { useContext } from "react";
import { Plan, PlanCategoryType, PlanSNPType } from "../@types";
import { isMaPlanType, isMapdPlanType } from "../helpers/planTypes";
import { useTranslate } from "../helpers/intlHooks";
import EnrollButtonForm from "./EnrollButtonForm";
import { makePlanDisplayId, PreviewContext } from "../helpers";
import { FocusableHeader } from ".";
import { withRouter, RouteComponentProps } from "react-router";

interface PlanHeaderProps extends RouteComponentProps {
  plan: Plan;
}

const PlanHeader: React.FunctionComponent<PlanHeaderProps> = ({ plan }) => {
  const t = useTranslate();
  const previewMode = useContext(PreviewContext);
  let planTypeKey;

  const { contract_year, contract_id, plan_id, segment_id } = plan;

  const isOriginalMedicare =
    ["2019", "2020"].includes(contract_year) &&
    contract_id === "H0001" &&
    plan_id === "001" &&
    segment_id === "0";

  if (isMaPlanType(plan.plan_type)) {
    planTypeKey = "plan_details.MA";
  } else if (isMapdPlanType(plan.plan_type)) {
    planTypeKey = "plan_details.MAPD";
  } else {
    planTypeKey = "plan_details.PDP";
  }

  if (plan.category === PlanCategoryType.REGIONAL_PPO) {
    planTypeKey = "plan_details.regional_ppo";
  } else if (plan.category === PlanCategoryType.MEDICARE_MEDICAID_PLAN) {
    planTypeKey = "plan_details.medicare_medicaid_plan";
  }

  let snpTypeKey;
  if (plan.snp_type === PlanSNPType.SNP_TYPE_DUAL_ELIGIBLE) {
    snpTypeKey = "plan_details.dual_eligible";
  } else if (plan.snp_type === PlanSNPType.SNP_TYPE_INSTITUTIONAL) {
    snpTypeKey = "plan_details.institutional";
  } else if (plan.snp_type === PlanSNPType.SNP_TYPE_CHRONIC_OR_DISABLING) {
    snpTypeKey = "plan_details.chronic_condition";
  }

  return (
    <div className="PlanHeader">
      <div className="PlanHeader__leftCol">
        <h6 className="ds-u-margin-bottom--0 ds-u-color--gray-light ds-u-text-transform--none">
          {plan.organization_name}
        </h6>
        <FocusableHeader
          className="ds-u-margin-y--0"
          text={plan.name}
          ignoreFocus={previewMode}
        />
        {!isOriginalMedicare && (
          <span className="PlanHeader__leftCol__text">
            {t("plan_details.plan_type")}:{" "}
            <span className="e2e-plan-details-plan-type">{t(planTypeKey)}</span>
            <br />
            {snpTypeKey && `${t("plan_details.snp_type")}: ${t(snpTypeKey)}`}
          </span>
        )}
        <span className="PlanHeader__leftCol__text ds-u-margin-top--1">
          {`${t("plan_terms.plan_id")}${makePlanDisplayId(plan)}`}
        </span>
      </div>
      <div className="PlanHeader__rightCol">
        {!previewMode && (
          <EnrollButtonForm plan={plan} tealiumEventAction="Plan Details" />
        )}
      </div>
    </div>
  );
};

export default withRouter(PlanHeader);
